import { z } from "zod";

export const DischargeLetterObstetricsFormSchema = z.object({
  anamnesis: z.string().optional(),
  course_of_labor: z.string().optional(),
  diagnoses: z.string().optional(),
  discharge_medications: z.string().optional(),
  discharge_status: z.string().optional(),
  discharge_summary: z.string().optional(),
  information_newborn: z.string().optional(),
  lab_results: z.string().optional(),
  physical_status: z.string().optional(),
  postpartum_recovery: z.string().optional(),
  recommendations: z.string().optional(),
});
